import React, { FC } from 'react';
import { parseClassnames } from '../../../helpers';
import { DialogContentProps } from '../../types';
import { PrimaryButton, InverseButton, TextLink } from '../../../Buttons';

export interface ActionProps
  extends Pick<DialogContentProps, 'type' | 'action' | 'dark' | 'className'> {
  actionType: '1' | '2' | '3' | 'cancel' | 'confirm';
}

const Action: FC<ActionProps> = ({
  type = 'm',
  action,
  actionType,
  dark,
  className = '',
}) => {
  if (action && !('label' in action)) {
    return React.cloneElement(action as React.ReactElement<any>, {
      // apply only tailwind classNames that are not provided
      className: parseClassnames(action.props.className || '', className),
    });
  }

  if (action && action.label) {
    const btnProps = { className, ...action };

    if (actionType === '1' || actionType === 'confirm') {
      return (
        <PrimaryButton
          size="l"
          full={type !== 'full' || actionType === 'confirm'}
          className={
            type !== 'm-form'
              ? parseClassnames(btnProps.className, 'max-w-280')
              : btnProps.className
          }
          darkMode={dark}
          {...btnProps}
        />
      );
    }
    if (actionType === '2' || actionType === 'cancel') {
      return (
        <InverseButton
          size="l"
          gray={actionType === 'cancel'}
          full={type !== 'full' || actionType === 'cancel'}
          className={
            type !== 'm-form' || actionType === 'cancel'
              ? parseClassnames(btnProps.className, 'max-w-280')
              : btnProps.className
          }
          darkMode={dark}
          {...btnProps}
        />
      );
    }
    return <TextLink type="level2" {...btnProps} />;
  }
  return null;
};

export default Action;
